var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".button-remove[data-v-5fc04b54]{background-image:url(" + escape(require("../../../assets/button-remove.svg")) + ");background-size:28px 28px;min-height:28px;min-width:28px;display:inline-block;vertical-align:middle;background-repeat:no-repeat}.button-remove[data-v-5fc04b54]:hover{cursor:pointer}.button-add[data-v-5fc04b54]{background-image:url(" + escape(require("../../../assets/button-add.svg")) + ");background-size:28px 28px;min-height:28px;min-width:28px;display:inline-block;vertical-align:middle;background-repeat:no-repeat}.button-add[data-v-5fc04b54]:hover{cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5fc04b54","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/Backend/Porto.vue
// module id = 637
// module chunks = 0